(function () {
  function init() {
    var recent = document.getElementById('recently-viewed-products-grid');
    if (recent && !recent.dataset.ocuListReady) {
      recent.dataset.ocuListReady = 'true';
      function syncRecentSemantics() {
        recent.querySelectorAll('.slick-track').forEach(function (track) {
          if (track.getAttribute('role') !== 'list') track.setAttribute('role', 'list');
          if (!track.hasAttribute('aria-label')) track.setAttribute('aria-label', 'Recently viewed products');
        });
        recent.querySelectorAll('.slick-slide').forEach(function (slide) {
          if (slide.getAttribute('role') !== 'listitem') slide.setAttribute('role', 'listitem');
          slide.removeAttribute('aria-selected');
        });
      }
      new MutationObserver(syncRecentSemantics).observe(recent, {childList:true, subtree:true, attributes:true, attributeFilter:['role']});
      syncRecentSemantics();
    }
    document.querySelectorAll('.ocu-purchase-panel').forEach(function (panel) {
      if (panel.dataset.ocuOptionsReady) return;
      panel.dataset.ocuOptionsReady = 'true';
      var form = panel.querySelector('#add-to-cart-form');
      var cart = panel.querySelector('#product-add-to-cart');
      if (!form || !cart) return;
      var quantity = form.querySelector('.ocu-quantity-field');
      if (quantity) {
        var row = document.createElement('div');
        row.className = 'ocu-purchase-row';
        cart.parentNode.insertBefore(row, cart);
        row.appendChild(quantity);
        row.appendChild(cart);
      }
      var helper = form.querySelector('[data-ocu-options-help]');
      var pending = false;
      var appLocked = false;
      var beforeAppLock = false;
      function sync() {
        pending = false;
        cart = form.querySelector('#product-add-to-cart') || cart;
        if (row && cart.parentNode !== row) row.appendChild(cart);
        form.querySelectorAll('.selector-wrapper select').forEach(function (field) {
          if (field.closest('#bcpo')) {
            Array.from(field.options).forEach(function (option) {
              if (option.value === '' && /^choose one$/i.test(option.textContent.trim())) {
                option.textContent = helper ? helper.textContent.trim() : 'Select Options';
              }
            });
          }
          var wrapper = field.closest('.selector-wrapper');
          if (!wrapper || field.disabled) return;
          if (helper && !field.getAttribute('aria-describedby')) field.setAttribute('aria-describedby', helper.id);
          var value = wrapper.querySelector('.ocu-option-value');
          if (!value) {
            value = document.createElement('p');
            value.className = 'ocu-option-value';
            value.setAttribute('aria-hidden', 'true');
            field.insertAdjacentElement('afterend', value);
          }
          var selected = field.selectedOptions[0];
          var text = selected && field.value ? selected.textContent.trim() : '';
          if (value.textContent !== text) value.textContent = text;
          var style = getComputedStyle(field);
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');
          context.font = style.font;
          var available = field.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
          value.hidden = !text || context.measureText(text).width <= available;
        });
        if (helper) {
          var unfinished = Array.from(form.querySelectorAll('#product-variants select.single-option-selector')).some(function (field) { return !field.value; });
          var appMissing = Array.from(form.querySelectorAll('#bcpo select[required],#bcpo textarea[required],#bcpo input[required]')).some(function (field) {
            if (field.disabled || field.type === 'hidden') return false;
            if (field.type === 'checkbox') return !field.checked;
            if (field.type === 'radio') return !Array.from(form.querySelectorAll('#bcpo input[type="radio"]')).some(function (choice) { return choice.name === field.name && choice.checked; });
            return !field.value.trim();
          });
          if (appMissing) {
            if (!appLocked) { beforeAppLock = cart.disabled; appLocked = true; }
            if (!cart.disabled) cart.disabled = true;
          } else if (appLocked) {
            appLocked = false;
            cart.disabled = beforeAppLock;
          }
          unfinished = unfinished || appMissing;
          helper.hidden = !unfinished;
          var payment = form.querySelector('.shopify-payment-button');
          if (payment) {
            payment.hidden = false;
            var express = payment.closest('.ocu-express-checkout');
            if (!express) {
              express = document.createElement('div');
              express.className = 'ocu-express-checkout';
              express.setAttribute('role', 'group');
              express.setAttribute('aria-label', 'Express checkout');
              if (helper) express.setAttribute('aria-describedby', helper.id);
              payment.before(express);
              express.appendChild(payment);
            }
            var blocked = unfinished || cart.disabled;
            express.setAttribute('aria-disabled', String(blocked));
            payment.inert = blocked;
          }
        }
      }
      function schedule() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(sync);
      }
      form.addEventListener('change', schedule);
      window.addEventListener('resize', schedule);
      new MutationObserver(function (records) {
        if (records.some(function (record) {
          if (record.type === 'attributes') return record.target.id === 'product-add-to-cart';
          return record.type === 'childList' && Array.from(record.addedNodes).some(function (node) {
            return node.nodeType === 1 && (node.matches('select,.selector-wrapper,#bcpo,#product-add-to-cart,.shopify-payment-button') || node.querySelector('select,#product-add-to-cart,.shopify-payment-button'));
          });
        })) schedule();
      }).observe(form, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled']});
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
